import { Box, Button, Pagination, TextField, Typography } from "@mui/material"
import EastIcon from '@mui/icons-material/East';
import { useEffect, useState } from "react";
import { TableComp } from "./Table";
import { BasePackageTableStyle } from "../../../utils/style/private-page/Style";
import { SearchIcon } from "../../../utils/icon/Private-Pages/Icon";

export const TablePagination = ({ prop }) => {
    const [goTo, setGoTo] = useState('')
    const { filteredData, rowsPerPage, next, previous, goto, page, setPage, handlePreviousPage, handleChangePage, totalPages } = prop
    const handleGoToPage = () => {
        const pageNumber = Number(goTo);
        if (pageNumber <= totalPages && pageNumber > 0) {
            setPage(pageNumber);
        } else if (pageNumber + 1 <= totalPages && pageNumber === 0) {
            setPage(1)
        }
        // setGoTo('');
    };

    const handleGoToInputChange = (event) => {
        setGoTo(event.target.value);
    };

    const handleGoToInputKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleGoToPage();
        }
    };
    return (
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', width: '100%', mt: 0, mb: 0, py: '10px', borderBottom: '1px solid #DADADA', borderRight: '1px solid #DADADA', borderLeft: '1px solid #DADADA', borderBottomRightRadius: '15px', borderBottomLeftRadius: '15px', }}>
            <Box></Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                {previous ?
                    <Button variant='outlined' onClick={handlePreviousPage} disabled={page === 1} sx={{ height: '30px', color: '#474747', display: { xs: 'none', sm: 'flex' }, px: 4, alignItems: 'center', borderColor: '#DADADA', justifyContent: 'space-evenly', textTransform: 'capitalize', '&:hover': { borderColor: '#DADADA' }, mr: 2, }}>
                        <EastIcon sx={{ transform: 'rotate(180deg)' }} />
                        Previous
                    </Button>
                    :
                    null}
                <Pagination count={Math.ceil(filteredData.length / rowsPerPage)} page={page} siblingCount={1} boundaryCount={1} hidePrevButton hideNextButton shape="rounded" onChange={handleChangePage} />
                {next ? <Button variant='outlined' onClick={() => setPage((x) => x + 1)} disabled={page >= totalPages} sx={{ height: '30px', color: '#474747', display: { xs: 'none', sm: 'flex' }, px: 4, alignItems: 'center', borderColor: '#DADADA', justifyContent: 'space-evenly', textTransform: 'capitalize', '&:hover': { borderColor: '#DADADA' }, ml: 2, }}>
                    Next
                    <EastIcon sx={{ ml: 1 }} />
                </Button> : null}
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', pr: 3 }}>
                <Typography sx={{ color: '#040815', fontSize: '12px', fontWeight: '400' }}>Go to</Typography>
                <Box sx={{ mx: 1 }}>
                    <TextField sx={{ '& .MuiOutlinedInput-root': { lineHeight: '26px', height: '26px', width: '50px', p: 0, '& fieldset': { height: '26px', width: '30px', borderRadius: '4px' }, '&:hover fieldset': {}, '&.Mui-focused fieldset': {}, }, }} value={goTo} onChange={handleGoToInputChange} onKeyDown={handleGoToInputKeyDown} onBlur={handleGoToPage} />
                    {/* <TextField sx={{ '& .MuiOutlinedInput-root': { lineHeight: '26px', height: '26px', width: '50px', p: 0, '& fieldset': { height: '26px', width: '30px', borderRadius: '4px' }, '&:hover fieldset': {}, '&.Mui-focused fieldset': {}, }, }} value={goTo} onChange={(e) => { setGoTo(e.target.value); if (e.target.value <= totalPages && Number(e.target.value) > 0) { setPage(e.target.value) } }} /> */}
                </Box>
                <Typography sx={{ color: '#040815', fontSize: '12px', fontWeight: '400' }}>Page</Typography>
            </Box>
        </Box>
    )
}

export const PackageTable = ({ prop }) => {
    const { border, next, previous, goto, borderBoxStyle, searchTerm, setSearchTerm, title, titleStyle, filteredData, tableStyle, tableProps, rowsPerPage, page, setPage } = prop;
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handlePreviousPage = () => {
        if (page > 1) {
            setPage(page - 1);
        }
    };

    const totalRows = filteredData?.length;
    const totalPages = Math.abs(Math.ceil(totalRows / rowsPerPage));
    const startIndex = Math.abs((page - 1) * rowsPerPage);
    const endIndex = Math.abs(Math.min(startIndex + rowsPerPage, totalRows));
    const paginatedData = filteredData?.slice(startIndex, endIndex);


    useEffect(() => { if (page >= totalPages && totalPages !== 0) { setPage(totalPages) } }, [totalPages])
    return (
        <Box sx={{}}>
            {totalRows !== 0 &&
                <Box sx={{ border: border && '0.8px solid #797F8F80', px: title && searchTerm !== undefined && setSearchTerm && 2, pb: 2, borderRadius: '8px', width: '100%', borderTopLeftRadius: { xs: '', md: 0 }, ...(borderBoxStyle ? { ...borderBoxStyle } : {}) }}>
                    <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexDirection: { xs: 'column', md: 'row' }, }}>
                        {title && <Typography sx={{ fontWeight: '600', fontSize: '16px', py: 3, color: '#000000', ...(titleStyle ? { ...titleStyle } : {}) }}>{title}</Typography>}
                        {searchTerm !== undefined && setSearchTerm && (
                            <Box sx={{ display: 'flex', alignItems: 'center', border: '1px solid #797F8F', borderRadius: '4px', padding: '0rem 1rem', width: '100%', height: '35px', maxWidth: '350px', }}>
                                <SearchIcon sx={{ color: '#757575', marginRight: '0.5rem' }} />
                                <TextField sx={{ flex: 1, '& .MuiOutlinedInput-root': { '& fieldset': { border: 'none', height: '35px' }, '&:hover fieldset': { border: 'none' }, '&.Mui-focused fieldset': { border: 'none' }, }, }} placeholder='Search...' variant='outlined' value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                            </Box>
                        )}
                    </Box>
                    <TableComp Data={paginatedData} Style={{ ...BasePackageTableStyle, isThreeDot: false, ...(tableStyle ? { ...tableStyle } : {}) }} {...tableProps} />
                    {totalRows > rowsPerPage ? <TablePagination prop={{ filteredData, rowsPerPage, page, setPage, next, previous, goto, handlePreviousPage: handlePreviousPage, handleChangePage: handleChangePage, totalPages: totalPages }} /> : null}
                </Box>
            }
        </Box>
    )
}